import { MobilePushChannel } from "@api-types/push-notifications/PushNotificationsDto";

export type GroupedSettings = {
	groupName: string;
	item: MobilePushChannel[];
	value: string;
};

export enum ThreeStateToggleEnum {
	OFF = "0",
	PARTIAL = "1",
	ON = "2",
}
